@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.client_charge.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mifos_mobile.feature.client_charge.generated.resources/"

internal val Res.drawable.database_checkmark: DrawableResource by lazy {
      DrawableResource("drawable:database_checkmark", setOf(
        ResourceItem(setOf(), "${MD}drawable/database_checkmark.xml", -1, -1),
      ))
    }

internal val Res.drawable.database_warning: DrawableResource by lazy {
      DrawableResource("drawable:database_warning", setOf(
        ResourceItem(setOf(), "${MD}drawable/database_warning.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("database_checkmark", Res.drawable.database_checkmark)
  map.put("database_warning", Res.drawable.database_warning)
}
